import { getVehicleFuelFunction } from '@/common/queries/selections/getVehicleFuel/getVehicleFuelQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getVehicleFuelQueryOptions = () => {
  return queryOptions({
    queryKey: ['getVehicleFuelQueryOptions'],
    queryFn: () => getVehicleFuelFunction(),
    select: (data) =>
      data?.map((item) => ({
        label: item.fa_const,
        value: item.const,
      })),
  });
};
